<template>
  <div class="dashboard-header">
    <div class="dashboard-header-left">
      <h1 class="bold">{{ property.name }} Dashboard</h1>
    </div>
    <div class="dashboard-header-right">
      <form @submit.prevent="search">
        <input
          ref="searchField"
          v-model.trim="searchKeywords"
          class="search-input"
          type="text"
          placeholder="search feedback"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'search all feedback'"
          required
        />
        <button type="submit" class="button button-100">Search</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardTitleSearch",
  props: {
    propertyName: {
      default: "Company",
      type: String
    },
    propertyId: {
      default: "",
      type: String
    },
    categoryId: {
      default: null,
      type: Number
    },
    sentimentScore: {
      default: null,
      type: Number
    }
  },
  data() {
    return {
      searchKeywords: ""
    };
  },
  computed: {
    property() {
      return this.$store.getters.property;
    }
  },
  methods: {
    search: function() {
      console.log(this.propertyId);
      let searchKeywords = this.searchKeywords
        .replace(/\s+/g, "+")
        .toLowerCase();
      this.$router.push({
        name: "dashboardFeedbackSearch",
        query: {
          propertyID: this.propertyId,
          searchKeywords: searchKeywords,
          page: 1,
          categoryId: this.categoryId
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dashboard-header {
  lost-utility: clearfix;
}
.dashboard-header-left {
  lost-column: 1/2;
  margin-bottom: 5px;
}
.dashboard-header-right {
  lost-column: 1/2;
  text-align: right;
  font-size: 15px;
}
.search-input {
  width: 300px;
  height: 36px;
  padding: 0 5px !important;
  margin: 5px 2px 3px 0 !important;
  font-size: 15px !important;
  vertical-align: bottom;
}
@media (max-width: 920px) {
  .search-input {
    width: 200px;
  }
}
@media (max-width: 720px) {
  .search-input {
    width: 280px;
  }
  .dashboard-header-left {
    lost-column: 1/1;
  }
  .dashboard-header-right {
    lost-column: 1/1;
  }
}
</style>
